import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img 
            src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/0qosaxkh_971B3874-1CF5-4E9F-8857-70C3B9D443B1.png" 
            alt="The Keeper Lab"
            className="footer-logo"
          />
          <p className="footer-tagline">Goalkeeper Representation & Development</p>
          <p className="footer-motto">Protecting the Last Line.</p>
        </div>

        <div className="footer-sections">
          <div className="footer-section">
            <h4>Contacto</h4>
            <div className="footer-links">
              <a href="mailto:info@thekeeperlab.com" className="footer-link">
                <Mail size={16} />
                <span>info@thekeeperlab.com</span>
              </a>
              <a href="tel:+56912345678" className="footer-link">
                <Phone size={16} />
                <span>+56 9 1234 5678</span>
              </a>
              <div className="footer-link">
                <MapPin size={16} />
                <span>Santiago, Chile</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Servicios</h4>
            <div className="footer-links">
              <a href="#services" className="footer-link-text">Representación</a>
              <a href="#services" className="footer-link-text">Desarrollo Mental</a>
              <a href="#services" className="footer-link-text">Gestión Contractual</a>
              <a href="#services" className="footer-link-text">Marca Personal</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>The Keeper Lab</h4>
            <div className="footer-links">
              <a href="#story" className="footer-link-text">Nuestra Historia</a>
              <a href="#manifesto" className="footer-link-text">Manifiesto</a>
              <a href="#application" className="footer-link-text">Aplicar</a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 The Keeper Lab. Todos los derechos reservados.</p>
        <div className="footer-legal">
          <a href="#privacy">Privacidad</a>
          <span className="separator">•</span>
          <a href="#terms">Términos</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
